import { Flex, Spin } from "antd";
import type { ReactNode } from "react";
import CustomEmpty from "./CustomEmpty";
const CustomLoader = ({
  children,
  isLoading,
  isEmpty = false,
}: {
  children: ReactNode;
  isLoading: boolean;
  height?: number;
  isEmpty?: boolean;
}) => {
  if (isEmpty && !isLoading) {
    return (
      <Flex
        align="center"
        justify="center"
        className="p-6 bg-white rounded-lg min-h-[200px]"
      >
        <CustomEmpty />
      </Flex>
    );
  }
  return (
    <div className="relative">
      {isLoading && (
        <div className="absolute left-0 right-0 top-0 bottom-0 bg-white/80 z-50 w-ful h-full flex items-center justify-center flex-col gap-2">
          <Spin className="" size="large" />
          <span className="text-display-body font-medium text-sm ml-2">
            Loading...
          </span>
        </div>
      )}
      {children}
    </div>
  );
};

export default CustomLoader;
